import React from "react";
import SectionTitle from "../UI/SectionTitle";
//founders
import Founders from "../../components/Team/founders/Founders";
import centralMainTeam from "../../data/Adminteam/centralMainTeam.json";
import founderData from "../../data/Founders/founders.json";
import CentralTeamComponent from "../../components/Team/adminteam/Adminteam";

// src\components\Team\adminteam\Adminteam.js

const Preview = () => {
  return (
    <div className="team-area-wrapper bg-img sp-top">
      <div className="container-fluid">
        <h2 style={{ color: "#ef586f" }}>Know Our Team</h2>
        <p
          className="col-lg-12 text-center custom-text"
          style={{
            fontSize: "17px",
            fontWeight: 300,
            color: "#000000 !important",
          }}
        >
          Kangaroocare is guided by a dynamic Core Leadership Team and a
          seasoned Management Team, each made up of accomplished experts at the
          peak of their professions. United in purpose, we are committed to
          delivering exceptional care and world-class medical excellence.
        </p>
      </div>

      <div className="team-area-wrapper bg-img sp-y">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-12 text-center ">
              <SectionTitle
                variant="black"
                title="Our Founders"
                heading=""
                text="The leaders of the pack are our pride. Their accomplishments talk for themselves"
                image={require("../../assets/img/separator7.svg")}
                headerStyle={{ color: "#ef586f" }}
              />

              <div className="founder-item-container">
                {founderData
                  .filter((item) => item.text === "Founder")
                  .map((team) => (
                    <div key={team.id}>
                      <Founders
                        id={team.id}
                        text={team.text}
                        image={team.image}
                        name={team.name}
                        link={team.link}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-12 text-center ">
              <SectionTitle
                variant="black"
                title="Board of Directors"
                heading=""
                text=""
                image={require("../../assets/img/separator7.svg")}
                headerStyle={{ color: "#ef586f" }}
              />

              <div className="founder-item-container">
                {founderData
                  .filter((item) => item.text !== "Founder")
                  .map((team) => (
                    <div key={team.id}>
                      <Founders
                        id={team.id}
                        text={team.text}
                        image={team.image}
                        name={team.name}
                        link={team.link}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {/* Board of Directors */}
          <div className="row align-items-center">
            <div className="col-lg-12 text-center">
              <SectionTitle
                variant="black"
                title="CORPORATE TEAM"
                heading=""
                text=""
                image={require("../../assets/img/separator7.svg")}
                headerStyle={{ color: "#ef586f" }}
              />

              <div className="founder-item-container">
                {centralMainTeam.map((team) => (
                  <div className="">
                    <div key={team.id}>
                      <CentralTeamComponent
                        id={team.id}
                        text={team.text}
                        image={team.image}
                        name={team.name}
                        link={team.link}
                        place={team.place}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;
